import { create } from 'zustand';
import { GeneralConfig } from '../config/generalConfig';

interface LanguageStore {
  language: string;
  setLanguage: (lang: string) => void;
}

export const useLanguageStore = create<LanguageStore>((set) => ({
  language: GeneralConfig.language,
  setLanguage: (lang: string) => set({ language: lang }),
}));
